module.exports = __webpack_public_path__ + "img/django.3c148946.png";